export default {
  reset: (state) => {
    state.item = {
      invitationCourses: [],
      code: null,
      expiresAt: null,
    };
    state.isLoading = false;
  },
  setItem: (state, item) => {
    state.item = item;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
};
